import { useFieldArray, useFormContext, useWatch } from 'react-hook-form'

import { IconName } from 'ui/components'
import { IconButton } from 'ui/components/Buttons'
import { SarEdit } from '~bank-bsa-reporting/types'

import { emptySAR } from '../../../../../../../../../constants'
import { InstitutionActivityBranchesItem } from './InstitutionActivityBranchesItem'

export const InstitutionActivityBranchesInfo = ({ index }: { index: number }) => {
  const { control } = useFormContext<SarEdit>()

  const { fields, append, remove } = useFieldArray({
    control,
    name: `institutionActivitiesInfo.${index as 0}.institutionActivityBranchesInfo`
  })

  const noBranchInvolved = useWatch({ control, name: `institutionActivitiesInfo.${index as 0}.noBranchInvolved` })

  return (
    <>
      {fields.map((field, index2) => (
        <InstitutionActivityBranchesItem
          key={field.id}
          index={index}
          index2={index2}
          showDeleteButton={fields.length > 1}
          onRemove={remove}
        />
      ))}
      {!noBranchInvolved && (
        <IconButton
          face="positive"
          icon={IconName.ADD_GREEN}
          onClick={() => {
            append(emptySAR.institutionActivitiesInfo[0].institutionActivityBranchesInfo[0])
          }}
        />
      )}
    </>
  )
}
